import { getConnectedChannelFilterString } from '../details/tabs/CompanyDetailHelper';

export function getAdjustedCompanyListDataForInnerSearch(companies: any) {
  if (companies == null) return null;

  companies.forEach((item: any) => {
    item.connectedChannels = getConnectedChannelFilterString(
      item.connectedChannel
    );
    if (item.companyOwnerName == null) item.companyOwnerName = '';
    if (item.activationOwnerName == null) item.activationOwnerName = '';
    if (item.hubSpotCompanyObjectId == null) item.hubSpotCompanyObjectId = '';
    if (item.cmsCompanyIndustry == null) item.cmsCompanyIndustry = '';
    if (item.hubSpotIndustry == null) item.hubSpotIndustry = '';
    if (item.npsScore == null) item.npsScore = '';
    if (item.cmsCompanyAdditionalInfo?.contractEndDate == null) {
      item.contractEndDate = '';
    }
  });
  return companies;
}

export const companyListFlowHubDataFields = [
  { key: 'numOfEnrolments', label: 'Enrolment (Current Usage Cycle)' },
  { key: 'enrolmentPercentage', label: 'Enrolment Percentage (%)' },
  { key: 'numOfWorkflows', label: 'Total Flows' },
  { key: 'numOfActiveWorkflows', label: 'Active Flows' },
  {
    key: 'maximumNumOfMonthlyWorkflowExecutions',
    label: 'Enrolment Limit'
  },
  { key: 'maximumNumOfWorkflows', label: 'Total Flow Limit' },
  { key: 'maximumNumOfActiveWorkflows', label: 'Active Flow Limit' },

  { key: 'maximumNumOfNodesPerWorkflow', label: 'Max Node Limit' },
  {
    key: 'isPurchasedFlowEnrolmentAddOn',
    label: 'Purchased Flow Enrolment Add-On'
  },
  { key: 'flowEnrolmentAddOnMrr', label: 'Flow Enrolment Add-On MRR (USD)' }
];

export const companyListIntelligentHubDataFields = [
  {
    key: 'totalAiFeaturesUsage',
    label: 'Inbox Co-pilot Credit Usage (Current Usage Cycle)'
  },
  {
    key: 'totalAiFeaturesUsageLimit',
    label: 'Inbox Co-pilot Credit Usage Limit'
  },
  {
    key: 'totalAiFeaturesUsagePercentage',
    label: 'Inbox Co-pilot Credit Usage Percentage (%)'
  },
  {
    key: 'totalAgentFeaturesUsage',
    label: 'AgentFlow Credit Usage (Current Usage Cycle)'
  },
  {
    key: 'totalAgentFeaturesUsageLimit',
    label: 'AgentFlow Credit Usage Limit'
  },
  {
    key: 'totalAgentFeaturesUsagePercentage',
    label: 'AgentFlow Credit Usage Percentage (%)'
  }
];

